import * as React from "react";
const SvgFiRrSquareC = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-c_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zM8.005 10.909v2.182c0 2.156 1.731 3.909 3.858 3.909h.545c1.307 0 2.522-.65 3.251-1.738a1.001 1.001 0 0 1 1.662 1.114 5.9 5.9 0 0 1-4.913 2.625h-.545c-3.23 0-5.858-2.651-5.858-5.909V10.91c0-3.258 2.628-5.909 5.858-5.909h.545c1.976 0 3.813.981 4.913 2.625a1 1 0 1 1-1.662 1.112A3.9 3.9 0 0 0 12.408 7h-.545c-2.127 0-3.858 1.753-3.858 3.909"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-c_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareC;
